export const MUTATION_ADD_TO_BASKET = 'ADD_TO_BASKET';
export const MUTATION_REMOVE_FROM_BASKET = 'REMOVE_FROM_BASKET';
export const MUTATION_RESET_BASKET = 'RESET_BASKET';
export const MUTATION_SET_QUANTITY_FOR_PRODUCT = 'SET_QUANTITY_FOR_PRODUCT';
